import LocalizedStrings from 'react-localization';
import Cookies from 'js-cookie';

import nl from './nl.json';
import de from './de.json';
import en from './en.json';

const strings = new LocalizedStrings({ nl, de, en });

if (Cookies.get('language')) {
  strings.setLanguage(Cookies.get('language'));
}

export default strings;



// WEBPACK FOOTER //
// ./src/locales/index.js